import { compareByLexicalOrder, rankBefore, rankAfter, rankBetween, type OrderBy } from './lexicalOrdering';
import type { FolderDto } from '../../src/dto/folderModels';

export function calculateSortKey(previous: FolderDto | null, next: FolderDto | null): string {
  if (!previous && !next) {
    throw new Error('Cannot calculate sort key without a previous or next folder');
  }

  if (!previous) {
    // reordering at the top
    const key = getFolderKey(next!);
    return rankBefore(key);
  }

  if (!next) {
    // reordering at the bottom
    const key = getFolderKey(previous);
    return rankAfter(key);
  }

  const previousKey = getFolderKey(previous);
  const nextKey = getFolderKey(next);
  return rankBetween(previousKey, nextKey);
}

function getFolderKey(folder: FolderDto): string {
  return folder.sortKey || folder.name.toLowerCase(); // folder name is unique and case-insensitive
}

export function compareFoldersByLexicalOrder(
  a: FolderDto,
  b: FolderDto,
  orderBy: OrderBy = 'asc'
): number {
  const aKey = getFolderKey(a);
  const bKey = getFolderKey(b);

  return compareByLexicalOrder(aKey, bKey, orderBy);
}
